"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    PclnUcChatBot: ()=>PclnUcChatBot,
    PROMPT_LIMIT: ()=>PROMPT_LIMIT
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const experimentation_namespaceObject = require("@pcln/experimentation");
var experimentation_default = /*#__PURE__*/ __webpack_require__.n(experimentation_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
const external_ChatContent_js_namespaceObject = require("./ChatContent.js");
var external_ChatContent_js_default = /*#__PURE__*/ __webpack_require__.n(external_ChatContent_js_namespaceObject);
const DialogContentWrapper_js_namespaceObject = require("./components/DialogContentWrapper.js");
const ChatMessageErrorBoundary_js_namespaceObject = require("./components/ErrorBoundary/ChatMessageErrorBoundary.js");
var ChatMessageErrorBoundary_js_default = /*#__PURE__*/ __webpack_require__.n(ChatMessageErrorBoundary_js_namespaceObject);
const index_js_namespaceObject = require("./components/ErrorComponent/index.js");
var index_js_default = /*#__PURE__*/ __webpack_require__.n(index_js_namespaceObject);
const DefaultModalHeader_js_namespaceObject = require("./components/Header/DefaultModalHeader.js");
const GoogleMapComponents_js_namespaceObject = require("./components/Maps/GoogleMapComponents.js");
var GoogleMapComponents_js_default = /*#__PURE__*/ __webpack_require__.n(GoogleMapComponents_js_namespaceObject);
const PennyCaresSurvey_js_namespaceObject = require("./components/Survey/PennyCaresSurvey.js");
var PennyCaresSurvey_js_default = /*#__PURE__*/ __webpack_require__.n(PennyCaresSurvey_js_namespaceObject);
const Survey_js_namespaceObject = require("./components/Survey/Survey.js");
var Survey_js_default = /*#__PURE__*/ __webpack_require__.n(Survey_js_namespaceObject);
const ChatProvider_js_namespaceObject = require("./context/ChatProvider.js");
const DialogStyleProvider_js_namespaceObject = require("./context/DialogStyleProvider.js");
const useAlertDialogState_js_namespaceObject = require("./hooks/useAlertDialogState.js");
const useChatBotState_js_namespaceObject = require("./hooks/useChatBotState.js");
const useChatMessagesState_js_namespaceObject = require("./hooks/useChatMessagesState.js");
const useChatUIState_js_namespaceObject = require("./hooks/useChatUIState.js");
const useLoadingState_js_namespaceObject = require("./hooks/useLoadingState.js");
const useLoadPreviousPrompts_js_namespaceObject = require("./hooks/useLoadPreviousPrompts.js");
var useLoadPreviousPrompts_js_default = /*#__PURE__*/ __webpack_require__.n(useLoadPreviousPrompts_js_namespaceObject);
const usePromptRetrieval_js_namespaceObject = require("./hooks/usePromptRetrieval.js");
var usePromptRetrieval_js_default = /*#__PURE__*/ __webpack_require__.n(usePromptRetrieval_js_namespaceObject);
const useRealTimeState_js_namespaceObject = require("./hooks/useRealTimeState.js");
const useSuppressOnNativeWebView_js_namespaceObject = require("./hooks/useSuppressOnNativeWebView.js");
const external_RealTimeAudioPanel_js_namespaceObject = require("./RealTimeAudioPanel.js");
var external_RealTimeAudioPanel_js_default = /*#__PURE__*/ __webpack_require__.n(external_RealTimeAudioPanel_js_namespaceObject);
const browserStorage_js_namespaceObject = require("./utils/browserStorage.js");
const pennyCaresSurvey_js_namespaceObject = require("./utils/pennyCaresSurvey.js");
const PROMPT_LIMIT = 5;
const PclnUcChatBot = (props)=>{
    const { componentVersion, discoveryCitySelected, handleMarkerResponse, isChatBoxOpened, locale = 'en-us', markerComponents = {}, onChatDialogRendered, onClose, realtimeContext, resolvedConfig, resolvedDisplay, resolvedFeatures, resolvedPayload } = props;
    const { shouldSuppress } = (0, useSuppressOnNativeWebView_js_namespaceObject.useSuppressOnNativeWebView)();
    if (shouldSuppress) return null;
    const { requestFrom, debugMode, fetchRequestOptions, retrieveUrl } = resolvedConfig ?? {};
    const browserStorage = browserStorage_js_namespaceObject.browserStorageManager.initBrowserStorage(requestFrom);
    const { setiValues = {}, quickActionsStackVariant, isSurveyEligible, isCaresSurveyEligible } = resolvedFeatures ?? {};
    const { isRealtime, isCaresSurveyEnabled } = setiValues;
    const { chatContainerHeight, dialogOverlayProps } = resolvedDisplay ?? {};
    const { isMobile, submitChatMessagesPayload } = resolvedPayload;
    const { productId, cguid, hotelPayload, isSessionActive } = submitChatMessagesPayload;
    const offerNumber = hotelPayload?.offerNumber;
    const pennyCareSurveyDone = 'undefined' != typeof window ? (0, pennyCaresSurvey_js_namespaceObject.isOfferSurveyDone)(offerNumber) : false;
    const isCaresSurveyEligibleAndEnabled = isCaresSurveyEligible && isCaresSurveyEnabled && !pennyCareSurveyDone;
    const { logAnalytics, speechFetchRequestOptions } = resolvedConfig || {};
    const { logChatInitialization, logCustomerCarePhoneNumberClicked, logCustomerCarePhoneNumberDisplayed, logFirstMessageSubmitted } = logAnalytics;
    const { chatMessages, setChatMessages, santizedSubmitChatMessagesPayload, setSanitizedSubmitChatMessagesPayload } = (0, useChatMessagesState_js_namespaceObject.useChatMessagesState)({
        submitChatMessagesPayload,
        resolvedFeatures
    });
    const { isLoading, setLoadingStatus, retrievalLoading, setRetrievalLoading, loadingStatusMessages, setLoadingStatusMessage, loadingHotelSkeleton, setLoadingHotelSkeleton } = (0, useLoadingState_js_namespaceObject.useLoadingState)();
    const { startRealTime, setStartRealTime } = (0, useRealTimeState_js_namespaceObject.useRealTimeState)({
        isRealtime
    });
    const isAlertDialogActive = (0, useAlertDialogState_js_namespaceObject.useAlertDialogState)();
    const { showSurvey, setShowSurvey, openErrorComponent, setOpenErrorComponent, isMapOpened, setIsMapOpened } = (0, useChatUIState_js_namespaceObject.useChatUIState)();
    const { audioPlayerRef, loadMoreMessages, setLoadMoreMessages, lastPromptId, setLastPromptId, telemetrySessionId } = (0, useChatBotState_js_namespaceObject.useChatbotState)({
        ...props,
        submitChatMessagesPayload
    });
    submitChatMessagesPayload.telemetrySessionId = telemetrySessionId;
    const visibilityChannel = new BroadcastChannel('chatbot-session-events');
    const enableVoice = setiValues?.enableVoice;
    const enableVoiceTooltip = setiValues?.enableVoiceTooltip;
    (0, external_react_namespaceObject.useEffect)(()=>{
        const handleMessage = (event)=>{
            const { count } = event.data;
            if (browserStorage) {
                browserStorage.updateUserMessageCount(count);
                if (count > 0) browserStorage.setInitialMessageSubmitted();
            }
        };
        visibilityChannel.addEventListener('message', handleMessage);
        return ()=>{
            visibilityChannel.removeEventListener('message', handleMessage);
        };
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        const updateMessageCountAsync = async ()=>{
            const userChatMessagesCount = chatMessages.filter((message)=>'user' === message.role && '' !== message.content).length;
            visibilityChannel.postMessage({
                count: userChatMessagesCount
            });
        };
        updateMessageCountAsync().catch((e)=>{});
    }, [
        chatMessages
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (isChatBoxOpened) {
            logChatInitialization();
            onChatDialogRendered();
            if (!resolvedConfig?.customerName && 'homePage' === requestFrom) experimentation_default().fireImpression('CHATBOT_VOICE_REALTIME_SIGNED_OUT');
        }
    }, [
        isChatBoxOpened,
        resolvedConfig?.customerName,
        onChatDialogRendered
    ]);
    usePromptRetrieval_js_default()({
        retrieveUrl,
        cguid,
        lastPromptId,
        setChatMessages,
        setRetrievalLoading,
        setLastPromptId,
        limit: PROMPT_LIMIT,
        isSessionActive: isSessionActive ?? true,
        productId,
        requestFrom,
        chatMessages
    });
    useLoadPreviousPrompts_js_default()({
        retrieveUrl,
        cguid,
        lastPromptId,
        limit: PROMPT_LIMIT,
        loadMoreMessages,
        setChatMessages,
        setRetrievalLoading,
        setLastPromptId,
        setLoadMoreMessages,
        isSessionActive: isSessionActive ?? true
    });
    const resolveSurvey = ()=>{
        if (isCaresSurveyEligibleAndEnabled) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(PennyCaresSurvey_js_default(), {
            onClose: onClose,
            offerNumber: offerNumber
        });
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Survey_js_default(), {
            onClose: function() {
                setShowSurvey(false);
                onClose();
            },
            requestFrom: requestFrom
        });
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatProvider_js_namespaceObject.ChatProvider, {
        chatbotData: {
            audioPlayerRef,
            chatContainerHeight,
            componentVersion,
            debugMode,
            discoveryCitySelected,
            enableVoice,
            enableVoiceTooltip,
            fetchRequestOptions,
            handleMarkerResponse,
            isDev: resolvedConfig?.isDev,
            isMobile,
            isRealtime,
            isSessionActive: true,
            loadMoreMessages,
            locale,
            logCustomerCarePhoneNumberClicked,
            logCustomerCarePhoneNumberDisplayed,
            logFirstMessageSubmitted,
            markerComponents,
            quickActionsStackVariant,
            requestFrom,
            setiValues,
            setLoadMoreMessages,
            shouldDisplayGenHotelFeature: setiValues?.shouldDisplayGenHotelFeature,
            speechFetchRequestOptions,
            submitChatMessagesPayload: santizedSubmitChatMessagesPayload,
            transcriptionFetchRequestOptions: resolvedConfig?.transcriptionFetchRequestOptions || {}
        },
        chatMessages: {
            chatMessages,
            setChatMessages,
            santizedSubmitChatMessagesPayload,
            setSanitizedSubmitChatMessagesPayload
        },
        loadingState: {
            isLoading,
            setLoadingStatus,
            retrievalLoading,
            setRetrievalLoading,
            loadingStatusMessages,
            setLoadingStatusMessage,
            loadingHotelSkeleton,
            setLoadingHotelSkeleton
        },
        ui: {
            showSurvey,
            setShowSurvey,
            openErrorComponent,
            setOpenErrorComponent,
            isMapOpened,
            setIsMapOpened,
            shouldDisplayMapButton: true
        },
        realtime: {
            setStartRealTime,
            startRealTime,
            isRealtime
        },
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(DialogStyleProvider_js_namespaceObject.DialogStyleProvider, {
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("audio", {
                    id: "penny-audio-player",
                    "data-testid": "penny-audio-player",
                    ref: audioPlayerRef,
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("track", {
                        kind: "captions"
                    })
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Dialog, {
                    showCloseButton: false,
                    scrimDismiss: !startRealTime,
                    open: isChatBoxOpened,
                    size: "lg",
                    onOpenChange: function(isOpen) {
                        if (!isOpen) onClose();
                    },
                    borderRadius: isMobile ? 'lg' : '2xl',
                    shouldDisableTabIndex: true,
                    ...dialogOverlayProps,
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DialogContentWrapper_js_namespaceObject.DialogContentWrapper, {
                        isAlertDialogActive: isAlertDialogActive,
                        ...dialogOverlayProps,
                        chatContainerHeight: chatContainerHeight,
                        children: startRealTime ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_RealTimeAudioPanel_js_default(), {
                            locale: locale,
                            realtimeContext: realtimeContext,
                            isModal: true,
                            requestFrom: requestFrom,
                            isCustomVoice: setiValues?.isCustomVoice ?? false
                        }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(DefaultModalHeader_js_namespaceObject.DefaultModalHeader, {
                                    onClose: function() {
                                        if (isSurveyEligible && !showSurvey && setiValues?.shouldDisplaySurvey || !showSurvey && isCaresSurveyEligibleAndEnabled) setShowSurvey(true);
                                        else {
                                            setShowSurvey(false);
                                            onClose();
                                        }
                                    },
                                    speechEnabled: setiValues?.enableVoice
                                }),
                                isMapOpened ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                                    compnentName: "GoogleMapComponents",
                                    FallbackComponent: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_js_default(), {}),
                                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(GoogleMapComponents_js_default(), {
                                        setiValues: setiValues
                                    })
                                }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChatMessageErrorBoundary_js_default(), {
                                    FallbackComponent: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_js_default(), {}),
                                    children: setiValues?.shouldDisplaySurvey && showSurvey || isCaresSurveyEligibleAndEnabled && showSurvey ? resolveSurvey() : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ChatContent_js_default(), {
                                        retrievalLoading: retrievalLoading,
                                        visibilityChannel: visibilityChannel
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
exports.PROMPT_LIMIT = __webpack_exports__.PROMPT_LIMIT;
exports.PclnUcChatBot = __webpack_exports__.PclnUcChatBot;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "PROMPT_LIMIT",
    "PclnUcChatBot"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
